import React from 'react';
import Navbar from './Navbar';
const Carbono = () => {
  return (
    <>
    <Navbar />
    <div>
      <h1>Carbono Page</h1>
      <p>Information about Carbono.</p>
    </div>
    </>
  );
};

export default Carbono;
